import * as z from "zod";

import { boardMeetingSchema } from "./board-meeting";
import { boardMeetingConfirmationSchema } from "./board-meeting-confirmation";
import { userSchema } from "./user";

export const boardMeetingWithPeopleSchema = boardMeetingSchema.extend({
  caller: userSchema,
  called: z.array(userSchema).default([]),
  attended: z.array(userSchema).default([]),
  secretary: userSchema.optional(),
  verifiers: z.array(userSchema).default([]),
  confirmations: z.array(boardMeetingConfirmationSchema).default([]),
});

export type BoardMeetingWithPeople = z.infer<
  typeof boardMeetingWithPeopleSchema
>;
